import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../components/angle/Panel/index';
import Spinner from '../../../components/Spinner/index';
import { FILING_STATUS } from '../../../services/constant/constant';
import EditPendingFilingForm from './EditFilingForm';
import { fetchMailingMethodTypes } from '../../../services/redux/commonData/actions';
import {
    fetchFilingById,
    updateFiling,
    approveFiling,
    denyFiling,
    inProgressFiling,
    holdFiling,
    setToHoldForPaymentFiling,
    setToReadyForRenewalFiling,
    terminateFiling,
    exemptFiling,
    changeFilingStatus,
    updateEditFilingPayload
} from '../../../services/redux/employee/filing/actions';

class FilingDetails extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        let { fetchMailingMethodTypes } = this.props;
        fetchMailingMethodTypes();
    }

    onUpdateClick = () => {
        let { filing, updateFiling, fetchFilingById } = this.props;

        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            response => {
                if (response.status === 200) {
                    fetchFilingById(filing.editFiling.filingId);
                }
            }
        );
    };

    onSaveApproveClick = () => {
        let {
            filing,
            history,
            updateFiling,
            approveFiling,
            location
        } = this.props;
        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            ufRes => {
                if (ufRes.status === 200) {
                    approveFiling(filing.editFiling.filingId).then(afRes => {
                        if (afRes.status === 200) {
                            history.push({
                                pathname: location.from,
                                from: '/filing-details'
                            });
                        }
                    });
                }
            }
        );
    };

    onDenyClick = () => {
        let { filing, history, denyFiling, location } = this.props;
        denyFiling(filing.editFiling.filingId).then(response => {
            if (response.status === 200) {
                history.push({
                    pathname: location.from,
                    from: '/filing-details'
                });
            }
        });
    };

    onInProgressClick = () => {
        let {
            filing,
            history,
            updateFiling,
            inProgressFiling,
            location
        } = this.props;
        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            ufRes => {
                if (ufRes.status === 200) {
                    inProgressFiling(filing.editFiling.filingId).then(
                        response => {
                            if (response.status === 200) {
                                history.push({
                                    pathname: location.from,
                                    from: '/filing-details'
                                });
                            }
                        }
                    );
                }
            }
        );
    };

    onHoldClick = () => {
        let {
            filing,
            history,
            updateFiling,
            holdFiling,
            location
        } = this.props;
        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            ufRes => {
                if (ufRes.status === 200) {
                    holdFiling(filing.editFiling.filingId).then(response => {
                        if (response.status === 200) {
                            history.push({
                                pathname: location.from,
                                from: '/filing-details'
                            });
                        }
                    });
                }
            }
        );
    };

    onBackClick = () => {
        let { history, location } = this.props;
        history.push({
            pathname: location.from,
            from: '/filing-details'
        });
    };

    onSetFilingAsSentClick = () => {
        let {
            filing,
            updateFiling,
            changeFilingStatus,
            fetchFilingById
        } = this.props;
        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            ufRes => {
                if (ufRes.status === 200) {
                    changeFilingStatus(
                        filing.editFiling.filingId,
                        FILING_STATUS.FILING_SENT
                    ).then(afRes => {
                        if (afRes.status === 200) {
                            fetchFilingById(filing.editFiling.filingId);
                        }
                    });
                }
            }
        );
    };

    onMarkAsFiledClick = () => {
        let {
            filing,
            history,
            updateFiling,
            changeFilingStatus,
            location
        } = this.props;
        updateFiling(filing.editFiling.filingId, filing.editFiling).then(
            ufRes => {
                if (ufRes.status === 200) {
                    changeFilingStatus(
                        filing.editFiling.filingId,
                        FILING_STATUS.APPROVED
                    ).then(afRes => {
                        if (afRes.status === 200) {
                            history.push({
                                pathname: location.from,
                                from: '/filing-details'
                            });
                        }
                    });
                }
            }
        );
    };

    onHoldForPaymentClick = () => {
        let { filing, setToHoldForPaymentFiling, fetchFilingById } = this.props;
        setToHoldForPaymentFiling(filing.editFiling.filingId).then(response => {
            if (response.status === 200) {
                fetchFilingById(filing.editFiling.filingId);
            }
        });
    };

    onRemoveHoldForPaymentClick = () => {
        let {
            filing,
            setToReadyForRenewalFiling,
            fetchFilingById
        } = this.props;
        setToReadyForRenewalFiling(filing.editFiling.filingId).then(
            response => {
                if (response.status === 200) {
                    fetchFilingById(filing.editFiling.filingId);
                }
            }
        );
    };

    onTerminateClick = () => {
        let { filing, terminateFiling, fetchFilingById } = this.props;
        terminateFiling(filing.editFiling.filingId).then(response => {
            if (response.status === 200) {
                fetchFilingById(filing.editFiling.filingId);
            }
        });
    };

    onExemptClick = () => {
        let { filing, exemptFiling, fetchFilingById } = this.props;
        exemptFiling(filing.editFiling.filingId).then(response => {
            if (response.status === 200) {
                fetchFilingById(filing.editFiling.filingId);
            }
        });
    };

    render() {
        let {
            filing,
            commonData,
            updateEditFilingPayload,
            roleName
        } = this.props;
        let isAdmin = roleName === 'Administrator';
        let preApprovalStatuses = [
            FILING_STATUS.PENDING,
            FILING_STATUS.IN_PROGRESS,
            FILING_STATUS.ON_HOLD,
            FILING_STATUS.EXEMPTION_APPROVED,
            FILING_STATUS.EXEMPTION_QUERIED,
            FILING_STATUS.CLIENT_CANCELLED,
            FILING_STATUS.DENIED
        ];
        let approvedStatuses = [
            FILING_STATUS.HOLD_FOR_PAYMENT,
            FILING_STATUS.READY_FOR_RENEWAL
        ];

        let pendingStatuses = [
            FILING_STATUS.READY_FOR_RENEWAL,
            FILING_STATUS.PENDING,
            FILING_STATUS.IN_PROGRESS
        ];

        let updateButton = isAdmin && (
            <button
                key="updateFilingButton"
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onUpdateClick}
            >
                Update
            </button>
        );

        let inProgressButton = preApprovalStatuses.includes(
            filing.editFiling.filingStatus
        ) &&
            isAdmin && (
                <button
                    key="editFilingInProgressButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onInProgressClick}
                >
                    In progress
                </button>
            );

        let holdButton = preApprovalStatuses.includes(
            filing.editFiling.filingStatus
        ) &&
            isAdmin && (
                <button
                    key="editFilingHoldButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onHoldClick}
                >
                    Hold
                </button>
            );

        let denyButton = preApprovalStatuses.includes(
            filing.editFiling.filingStatus
        ) &&
            isAdmin && (
                <button
                    key="editFilingDenyButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onDenyClick}
                >
                    Deny
                </button>
            );

        let holdForPaymentButton = filing.editFiling.filingStatus ===
            FILING_STATUS.READY_FOR_RENEWAL &&
            isAdmin && (
                <button
                    key="holdForPaymentButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onHoldForPaymentClick}
                >
                    Hold for Payment
                </button>
            );

        let setFilingAsSentButton = approvedStatuses.includes(
            filing.editFiling.filingStatus
        ) &&
            isAdmin && (
                <button
                    key="setFilingAsSentButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onSetFilingAsSentClick}
                >
                    Set filing as sent
                </button>
            );

        let markAsFiledButton = (filing.editFiling.filingStatus ===
            FILING_STATUS.FILING_SENT ||
            preApprovalStatuses.includes(filing.editFiling.filingStatus) ||
            approvedStatuses.includes(filing.editFiling.filingStatus)) &&
            isAdmin && (
                <button
                    key="markAsFiledButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onMarkAsFiledClick}
                >
                    Mark As Filed
                </button>
            );

        let removeHoldForPaymentButton = filing.editFiling.filingStatus ===
            FILING_STATUS.HOLD_FOR_PAYMENT &&
            isAdmin && (
                <button
                    key="removeHoldForPaymentButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onRemoveHoldForPaymentClick}
                >
                    Remove Hold for Payment
                </button>
            );

        let terminateButton = filing.editFiling.filingStatus ===
            FILING_STATUS.READY_FOR_RENEWAL &&
            isAdmin && (
                <button
                    key="terminateButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onTerminateClick}
                >
                    Terminate
                </button>
            );

        let exemptButton = pendingStatuses.includes(
            filing.editFiling.filingStatus
        ) &&
            isAdmin && (
                <button
                    key="exemptButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onExemptClick}
                >
                    Exempt
                </button>
            );

        let backButton = (
            <button
                key="editFilingBackButton"
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        let readyForRenewalButton = [
            FILING_STATUS.TERMINATED,
            FILING_STATUS.APPROVED
        ].includes(filing.editFiling.filingStatus) &&
            isAdmin && (
                <button
                    key="readyForRenewalButton"
                    type="button"
                    className="btn btn-default btn-bordered"
                    onClick={this.onRemoveHoldForPaymentClick}
                >
                    Ready for renewal
                </button>
            );

        const buttonList = [
            updateButton,
            setFilingAsSentButton,
            markAsFiledButton,
            inProgressButton,
            holdButton,
            denyButton,
            holdForPaymentButton,
            removeHoldForPaymentButton,
            exemptButton,
            terminateButton,
            readyForRenewalButton,
            backButton
        ];

        return (
            <div>
                <Panel
                    showHeader
                    header="Filing Details"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div className="col-lg-6 col-md-8 col-sm-12">
                        <EditPendingFilingForm
                            editFilingData={filing.editFiling}
                            filingInfoData={filing.filingInfoData}
                            clientData={filing.clientData}
                            stateData={filing.stateData}
                            mailingMethods={commonData.mailingMethodTypes}
                            updateFilingData={updateEditFilingPayload}
                            formRef={this.formRef}
                            isEditable={isAdmin}
                        />
                    </div>
                </Panel>
                {filing.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    filing: state.employee.filing,
    commonData: state.commonData,
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchFilingById,
            fetchMailingMethodTypes,
            updateFiling,
            approveFiling,
            denyFiling,
            inProgressFiling,
            holdFiling,
            setToHoldForPaymentFiling,
            setToReadyForRenewalFiling,
            terminateFiling,
            exemptFiling,
            changeFilingStatus,
            updateEditFilingPayload
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(FilingDetails));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/FilingDetails.js